import { create } from "zustand";
import Cookies from "js-cookie";
import { axiosInstance } from "../lib/axios";
import { useNavigate } from "react-router-dom";
import { getCategoryapi } from "../api/category";


export const useCategoryStore = create((set, get) => ({
    category: null,
    loading: false,
    selectedCategory: null,
    selectedCategoryName: "All",
    setSelectedCategory: (id, name) => set({ selectedCategory: id, selectedCategoryName: name }),


    getCategory: async () => {
        set({ loading: true })
        try {
            const res = await getCategoryapi()
            set({ loading: true, category: res?.ref })
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    }
}))